var _path;
function _extends() { return _extends = Object.assign ? Object.assign.bind() : function (n) { for (var e = 1; e < arguments.length; e++) { var t = arguments[e]; for (var r in t) ({}).hasOwnProperty.call(t, r) && (n[r] = t[r]); } return n; }, _extends.apply(null, arguments); }
import * as React from "react";
function SvgDownload(_ref, svgRef) {
  let {
    title,
    titleId,
    ...props
  } = _ref;
  return /*#__PURE__*/React.createElement("svg", _extends({
    width: 20,
    height: 20,
    viewBox: "0 0 20 20",
    fill: "none",
    xmlns: "http://www.w3.org/2000/svg",
    ref: svgRef,
    "aria-labelledby": titleId
  }, props), title ? /*#__PURE__*/React.createElement("title", {
    id: titleId
  }, title) : null, _path || (_path = /*#__PURE__*/React.createElement("path", {
    d: "M9.9998 13.3335L5.83313 9.16683L6.9998 7.9585L9.16646 10.1252V3.3335H10.8331V10.1252L12.9998 7.9585L14.1665 9.16683L9.9998 13.3335ZM4.9998 16.6668C4.54146 16.6668 4.1491 16.5036 3.82271 16.1772C3.49632 15.8509 3.33313 15.4585 3.33313 15.0002V12.5002H4.9998V15.0002H14.9998V12.5002H16.6665V15.0002C16.6665 15.4585 16.5033 15.8509 16.1769 16.1772C15.8505 16.5036 15.4581 16.6668 14.9998 16.6668H4.9998Z",
    fill: "black"
  })));
}
const ForwardRef = /*#__PURE__*/React.forwardRef(SvgDownload);
export default __webpack_public_path__ + "static/media/download.f5f93b195503c0b3b4853f60d419d0e4.svg";
export { ForwardRef as ReactComponent };